'use strict';

angular.module('userRequestEditControllers')

.controller('ByNetworkShareController', ['$scope', '$rootScope', '$q', '$state', 'editAccessRequestService', 'businessSystemService', 'userRequest', 'systemType', 'existingSysRoles', 'allowableSysRoles', 'defaultEntitlementSysRoles', 'sameAsEmployee', 'sameAsSysRoles', 'arrayHelpers', function ($scope, $rootScope, $q, $state, editAccessRequestService, businessSystemService, userRequest, systemType, existingSysRoles, allowableSysRoles, defaultEntitlementSysRoles, sameAsEmployee, sameAsSysRoles, arrayHelpers) {

    // Scopping
    $scope.systemType = systemType;

    if (!_.isUndefined(sameAsEmployee)) {
        $scope.sameAsEmployee = sameAsEmployee.data;
    }

    // Need refresh
    $scope.whenNeedRefresh = function () {
        $rootScope.$broadcast('needRefresh');
    }

    // Get pendings and existings
    var getPendingsAndExistings = function () {

        // Get all same as roles
        var sameAsList = _.filter(sameAsSysRoles, function (sameAs) {
            return sameAs.SystemTypeID === systemType.SystemTypeID;
        });
        $scope.userRequest.sameAsSysRoles = sameAsList;

        // Get all pendings roles
        var pendings = _.filter($scope.userRequest.SystemRolePendings, { SystemTypeID: systemType.SystemTypeID });
        $scope.userRequest.pendings = pendings;

        // Merge pendings and existings roles
        var existings = _.filter(existingSysRoles, { SystemTypeID: systemType.SystemTypeID });

        existings = editAccessRequestService.mergePendingsAndExistingsRoles(pendings, existings);
        $scope.userRequest.existings = existings;

        // Get default entitlements
        var defEntitlements = _.chain(defaultEntitlementSysRoles)
                               .filter(function (defEntitlement) {
                                   return defEntitlement.SystemTypeID === systemType.SystemTypeID;
                               })
                               .filter(function (defEntitlement) {
                                   return _.findIndex(sameAsList, { SystemRoleID: defEntitlement.SystemRoleID }) === -1;
                               })
                               .value();
        $scope.userRequest.defEntitlements = defEntitlements;

        // Get other allowables
        var allAllowables = _.filter(allowableSysRoles, function (allowable) {
            return _.findIndex(sameAsList, { SystemRoleID: allowable.SystemRoleID }) === -1;
        });

        // Union allowables and default entitlements
        var allowablesAndEntitlements = _.union(allAllowables, defEntitlements);
        allowablesAndEntitlements = _.chain(allowablesAndEntitlements)
                                     .uniq(function (e) { return e.SystemRoleID; })
                                     .filter(function (e) {
                                         return _.findIndex(existings, { SystemRoleID: e.SystemRoleID }) === -1;
                                     })
                                     .value();

        // Filter with search
        if ($scope.ctxSearchSystem.withSearch()) {
            allowablesAndEntitlements = _.filter(allowablesAndEntitlements, function (sysRole) {
                return !_.isUndefined(_.find($scope.ctxSearchSystem.systems, { SystemID: sysRole.SystemID }));
            });
        }

        // Add pending for allowables and default entitlements
        var otherAllowables = _.map(allowablesAndEntitlements, function (allowable) {
            var pending = _.find(pendings, { SystemRoleID: allowable.SystemRoleID })
            if (!_.isUndefined(pending)) {
                allowable.ToAdd = pending.ToAdd;
                allowable.ToRemove = pending.ToRemove;
                allowable.ToKeep = pending.ToKeep;
            }
            return allowable;
        });
        $scope.userRequest.otherAllowables = otherAllowables;

        $scope.userRequest.allowablesNotPendings = _.filter($scope.userRequest.otherAllowables, function (allowable) {
            return _.isUndefined(allowable.ToAdd);
        });

        // Get other pendings
        var otherPendings = _.filter(pendings, function (pending) {
            return !_.find(existings, { 'SystemRoleID': pending.SystemRoleID }) &&
                   !_.find(allowableSysRoles, { 'SystemRoleID': pending.SystemRoleID }) &&
                   !_.find(defEntitlements, { 'SystemRoleID': pending.SystemRoleID });
        });
        $scope.userRequest.otherPendings = otherPendings;
    }

    $scope.$watch('ctxSearchSystem.systems', function (newValue, oldValue) {
        getPendingsAndExistings();

        if ($scope.ctxSearchSystem.withSearch()) {
            $scope.searchOthers.term = $scope.ctxSearchSystem.searchTerm;
            $scope.searchOthers.search();
        }
        else {
            $scope.searchOthers.term = undefined;
            $scope.searchOthers.search();
        }
    }, true);

    // Search others
    $scope.searchOthers = {};
    $scope.searchOthers.term = null;

    $scope.searchOthers.search = function () {
        if (_.isUndefined($scope.searchOthers.term) || $scope.searchOthers.term.length <= 1) {
            $scope.searchOthers.results = null;
            return;
        }

        businessSystemService.searchOthersSystemRolesByRequestAndSystemType(
            userRequest.UserAccessRequestID, systemType.SystemTypeID, $scope.searchOthers.term)
        .then(function (results) {
            results = _.filter(results, function (result) {
                return !_.find($scope.userRequest.defEntitlements, { 'SystemRoleID': result.SystemRoleID });
            });

            $scope.searchOthers.noResults = results.length === 0;
            $scope.searchOthers.results = results;
        });
    }

    // Same As
    $scope.addAllSameAs = function () {

        $q.all(_.map($scope.userRequest.sameAsSysRoles, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Allowables
    $scope.addAllAllowables = function () {

        $q.all(_.map($scope.userRequest.allowablesNotPendings, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Remove all current permissions
    $scope.removeAllExistings = function () {
        var existingsToRemove = _.filter($scope.userRequest.existings, function (existing) {
            return _.isUndefined(existing.ToAdd);
        });

        $q.all(_.map(existingsToRemove, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preClose($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (removedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }
}]);